import { ApiUtil as api } from '@/utils/api.util.js'
import serialize from '@/helpers/serialize'

export class AssetService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/assets/'

  static all (queryParams = {}, config = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams, config).then(
      data => {
        return data
      },
      error => {
        throw error
      }
    )
  }

  static getAsset (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'firm/asset', queryParams)
  }
  static summary (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'summary', queryParams)
  }

  static show (id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + `${id}`, queryParams)
  }

  static create (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE, queryParams)
  }

  static import (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'import', queryParams).then(
      data => {
        return data
      },
      error => {
        throw error
      }
    )
  }

  static export (queryParams = {}, config = {}) {
    return api.get(this.URL + this.RESOURCE + 'export', queryParams, config)
  }

  static toggleHotspot (id) {
    return api.put(this.URL + this.RESOURCE + id + '/toggle-hotspot').then(
      data => {
        return data
      },
      error => {
        throw error
      }
    )
  }

  static listImports (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'imports', queryParams)
  }

  static createImport (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'imports', queryParams)
  }

  static statusImport (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'imports/status', queryParams)
  }

  static uploadImport (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'imports/upload', queryParams)
  }

  static downloadImport (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'imports/download', queryParams)
  }

  static processImport (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'imports/process', queryParams)
  }

  static instantProcessImport (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'imports/instant-process', queryParams)
  }

  static reverseImport (file_id) {
    return api.post(this.URL + this.RESOURCE + 'imports/reverse/' + file_id);
  }

  static importReport (queryParams = {}, config = {}) {
    return api.get(this.URL + this.RESOURCE + 'imports/report', queryParams, config)
  }

  static deleteImport (queryParams = {}) {
    return api.delete(
      this.URL + this.RESOURCE + 'imports?' + serialize(queryParams)
    )
  }

  static listCodes (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'codes', queryParams)
  }

  static listFiles (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'files', queryParams)
  }

  static geojson(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'geojson', queryParams)
  }

  static archive (id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + `${id}/archive`, queryParams)
  }

  static restore (id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + `${id}/restore`, queryParams)
  }
  
  static assignOrderTypeCode (data, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + "assign-orderType-code", data, { params: queryParams })
  }

  static unassignOrderTypeCode (data, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + "unassign-orderType-code", data, { params: queryParams })
  }

  static archiveContractTypeTags (data = {}) {
    return api.put(this.URL + this.RESOURCE + "archive-contract-type-tags", data)
  }

  static restoreContractTypeTags (data = {}) {
    return api.put(this.URL + this.RESOURCE + "restore-contract-type-tags", data)
  }

  static archiveContracts (data = {}) {
    return api.put(this.URL + this.RESOURCE + "archive-contracts", data)
  }

  static restoreContracts (data = {}) {
    return api.put(this.URL + this.RESOURCE + "restore-contracts", data)
  }
}



// WEBPACK FOOTER //
// ./src/services/asset.service.js